import React from "react";
import PropTypes from "prop-types";
import {
  InputRadio,
  Button,
  Type,
  DialogTitle,
  DialogTitleActions,
} from "discover.medical.react-component-library";
import { Fragment } from "react";
import {
  StyledDialogMessage,
  StyledRadioGroupLabel,
  StyledInputGroup,
  StyledTypeButtonWrapper,
  StyledCancelButton,
} from "./_.styled";

const InnerFollowDialog = ({
  onSave,
  onOptionChange,
  onRequestClose,
  selectedOption,
  modalData,
}) => {
  const {
    header,
    subheader,
    selectOptionHeader,
    selectOptions,
    followButton,
  } = modalData;

  return (
    <Fragment>
      <DialogTitle>
        <Type element="h2" fontFamily="secondary" color="gray800">
          {header}
        </Type>
        <DialogTitleActions onRequestClose={onRequestClose} />
      </DialogTitle>
      <StyledDialogMessage element="p" marginX="sm" marginTop="sm">
        {subheader}
      </StyledDialogMessage>
      {selectOptions.length > 0 && (
        <>
          <StyledRadioGroupLabel
            data-testid="dialog-select-options"
            element="p"
            fontWeight="bold"
            marginX="sm"
            marginTop="sm"
          >
            {selectOptionHeader}
          </StyledRadioGroupLabel>
          <StyledInputGroup
            data-testid="radiobutton-group"
            onChange={onOptionChange}
            selectedValue={selectedOption}
            marginX="sm"
            marginTop="sm"
          >
            {modalData.selectOptions.map(({ label, id }) => (
              <InputRadio
                id={id}
                label={label}
                name={selectOptionHeader}
                value={id}
              />
            ))}
          </StyledInputGroup>
        </>
      )}
      <StyledTypeButtonWrapper
        marginY="lg"
        width="100"
        display="inline-flex"
        justify={{ content: "center" }}
      >
        <Button
          data-testid="follow-dialog-follow-button"
          onClick={onSave}
          size="md"
          data-auto="follow-modal__follow-button"
          disabled={!selectedOption}
          marginRight="sm"
          align={{ items: "center" }}
        >
          {followButton.label}
        </Button>
        <StyledCancelButton
          data-testid="follow-dialog-cancel"
          onClick={onRequestClose}
          size="md"
          kind="text"
        >
          Cancel
        </StyledCancelButton>
      </StyledTypeButtonWrapper>
    </Fragment>
  );
};

InnerFollowDialog.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onOptionChange: PropTypes.func,
  selectedOption: PropTypes.string,
  modalData: PropTypes.object,
};

InnerFollowDialog.displayName = "InnerFollowDialog";

export default InnerFollowDialog;
